<template lang="pug">
  ul.pins.observe
    li(
      v-for="item in pinsData"
      :style='`top: ${item.location[0]}%; left: ${item.location[1]}%;`'
      v-bind:class="{ active: item.active }"
      @click="setActive(item)").pins__item.cursor__link
      .pins__item_button
      .pins__item_popup {{ item.text }}
</template>

<script>

export default {
  name: "Pins",
  data: () => ({
    pinsData: [
      {
        active: false,
        location: [61, 56.5],
        text: `The building is the first fully air-conditioned skyscraper. A high-speed radial compressor was invented specially for the structure and became the dominant design for decades afterwards.`
      },
      {
        active: false,
        location: [42, 39.7],
        text: `The tower is steel frame with an inner reinforced concrete core providing stability and resisting wind load. The core contains the area of elevator shafts, stairs, plant and mechanical systems.`
      },
      {
        active: false,
        location: [22, 49],
        text: `The tower has 3,862 windows. The building was the first in the world to have glass-wrapped corners, creating an impression that the tower was physically and visually light.`
      },
      {
        active: false,
        location: [55, 50],
        text: `The exterior walls are clad of brick, insulating but not loadbearing. The internal walls consist of soundproof steel partitions fitted with paneling and doors imitating walnut timber.`
      },
      {
        active: false,
        location: [71.2, 47.6],
        text: `The crown, its spire and decorative elements, i.e. gargoyles are made of corrosion-resistant Nirosta, the trade name for an alloy of chrome-nickel steel (“Enduro KA-2”) that was developed by Krupp.`
      },
    ]
  }),
  methods: {
    setActive(item){
      this.hiddenPins();
      item.active = true;
    },
    hiddenPins(){
      this.pinsData.forEach((item) => {
        item.active = false;
      })
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/sass/general/variables"
@import "src/sass/general/medias"
.pins
  position: absolute
  width: 100%
  height: 100%
  top: 0
  left: 0
  list-style-type: none
  padding: 0
  margin: 0
  &.animated
    .pins__item
      opacity: 1
      pointer-events: all
      transform: scale(1) translateY(0px)
      &:nth-child(1)
        transition-delay: 1.2s
      &:nth-child(2)
        transition-delay: 1.3s
      &:nth-child(3)
        transition-delay: 1.4s
      &:nth-child(4)
        transition-delay: 1.5s
      &:nth-child(5)
        transition-delay: 1.6s
      &:nth-child(6)
        transition-delay: 1.7s
      &:nth-child(7)
        transition-delay: 1.8s
      &:nth-child(8)
        transition-delay: 1.9s
      &:nth-child(9)
        transition-delay: 2.0s
      &:nth-child(10)
        transition-delay: 2.1s

.pins__item
  position: absolute
  color: white
  transitio-timing-function: ease
  opacity: 0
  pointer-events: none
  transform: scale
  transition-duration: .5s
  transform: scale(0) translateY(20px)
  &:hover
    .pins__item_button
      transform: scale(.7)
  &.active
    .pins__item_popup
      opacity: 1
      transform: translateY(0px)

.pins__item_popup
  position: absolute
  width: 360px
  color: $brown3
  font-size: 15px
  left: 55px
  pointer-events: none
  bottom: 48px
  transition-duration: .5s
  transition-timing-function: ease
  opacity: 0
  font-family: 'Futura PT Book'
  transform: translateY(-15px)
  @media (max-width: $s-desktop)
    width: 300px
  @media (max-width: $b-tablet)
    bottom: -88px
    width: 240px
    left: 15px
  @media (max-width: $xs-tablet)
    bottom: -88px
    width: 220px
    left: -155px
    text-align: right

.pins__item_button
  width: 12px
  height: 12px
  background-color: rgba(210, 173, 117, 1)
  border-radius: 100%
  cursor: pointer
  transition-duration: .6s
  opacity: 1
  border: none
  transition-timing-function: ease
  transform: scale(.5)
  animation: pulse 1s infinite

@keyframes pulse
	0%
		transform: scale(0.95)
		box-shadow: 0 0 0 0 rgba(210, 173, 117, 0.7)
	70%
		transform: scale(1)
		box-shadow: 0 0 0 10px rgba(210, 173, 117, 0)
	100%
		transform: scale(0.95)
		box-shadow: 0 0 0 0 rgba(210, 173, 117, 0)

</style>
